import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">{aboutData.title}</h2>
            <div className="w-16 h-1 bg-primary-500 rounded-full mx-auto mb-6"></div>
          </div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center">{aboutData.content}</p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">10,000+</div>
              <div className="text-xs text-foreground-400 mt-1">视频资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">千万级</div>
              <div className="text-xs text-foreground-400 mt-1">月活跃用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">99.9%</div>
              <div className="text-xs text-foreground-400 mt-1">播放成功率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}